import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import {
  SigIdCalculationRead,
  SigIdPayerServiceListItem,
  SigIdPayerServiceRead,
  SigIdPaymentRead
} from './sig-id.common.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SigIdCommonService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public getPayerServices(): Observable<SigIdPayerServiceRead[]> {
    return this.http.get<{ services?: SigIdPayerServiceRead[] }>(`${environment.apiBasePath}/sigid/payers`)
      .pipe(
        map((data) => data?.services || [])
      );
  }

  public getPayment(identSigId: string, serviceCode: string, idZap?: string): Observable<SigIdPaymentRead> {
    let params: HttpParams = new HttpParams();
    params = params.append('identSigid', identSigId);
    params = params.append('serviceCode', serviceCode);
    if (idZap) {
      params = params.append('idzap', idZap);
    }
    return this.http.get<{
      payment?: SigIdPaymentRead
    }>(`${environment.apiBasePath}/sigid/payments`, { params })
      .pipe(
        map((data) => data?.payment || {})
      );
  }

  public getCalculation(identSigId: string, serviceCode: string): Observable<SigIdCalculationRead> {
    return this.http.get<SigIdCalculationRead>(`${environment.apiBasePath}/sigid/calculations`, {
      params: {
        identSigid: identSigId,
        service: serviceCode
      }
    });
  }

  public getPayerServiceList(): Observable<SigIdPayerServiceListItem[]> {
    return this.getPayerServices().pipe(
      map(v => v.map(item => ({
        ...item,
        tag: `${item?.name || ''} ${item?.street || ''} ${item?.town}`
      })))
    );
  }
}
